import { IonContent, IonPage } from "@ionic/react"
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Head from "./Header";
import Sidebar from "./Sidebar";

const HomePage: React.FC = () => {
    const history = useHistory();
    const [name] = useState(localStorage.getItem("EmpName"));
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    
    // useEffect(() => {
    //     if (token === null) {
    //        // window.location.hash = '/Login'
    //     } else {
    //     }
    //   }, [token, history]);
    
    return (

        <IonPage>
            
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="page-title">Welcome {name}!</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage >
    )
}

export default HomePage;